export const Tick = () => (
  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.8624 17.949L0.321595 9.99538C-0.144005 9.52978 -0.0864046 8.76658 0.379195 8.35858C0.844795 7.89298 1.608 7.95058 2.016 8.41618L7.92 14.4978L22.0128 0.524981C22.4784 0.0593812 23.184 0.0593812 23.6496 0.524981C24.1152 0.990581 24.1152 1.69618 23.6496 2.16178L7.8624 17.949Z"
      fill="#74CF9A"
    />
  </svg>
);
